import React, { Component } from "react";
import ReactDOM from 'react-dom';
import GeneralDocumentForm from "./GeneralDocumentForm.jsx";
import Doc2SignDocumentForm from "./Doc2SignDocumentForm.jsx";
import MassiveCfdiForm from "./MassiveCfdiForm.jsx";
import AutomaticDocumentForm from "./AutomaticDocumentForm.jsx";

import { GENERAL_CATEGORY, AUTOMATIC_CATEGORY, DOC2SIGN_CATEGORY, CFDI_CATEGORY, CFDI } from '../constants';

import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
 
class DocumentForm extends Component {
    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.state = { 
            documentCategory:GENERAL_CATEGORY,
            documentTypesCategories:[], 
            document:[],
            loading: false  // Flag to indicate loading state
        }; 
    }

    async componentDidMount() { 
        const { lang } = this.context; 
        
        if (this.props.document_id != null) { 
            await this.getDocument(this.props.document_id)
        }
        this.setState({ 
            loading: true   
        });
        this.getDocumentTypesCategories();
    }
    async getDocument(id) {
        const response = await axios.get('/api/documents/' + id)
        this.setState({
            documentCategory: response.data.type.category.id,
            document: response.data,
            loading: true  // Set loading to false when document is fetched
        });
    } 
    
    getDocumentTypesCategories(){ 
        axios.get('/api/document_types_categories').then(res=>{ 
            this.setState({documentTypesCategories: res.data})
        })
    }
    componentDidUpdate() { 
    }

    handleSelectChange = (event) => {
        this.setState({ documentCategory: event.target.value });
    }

    render() { 
        const { lang } = this.context; 
        const { documentCategory } = this.state;
        return (
            <>
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
            <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                <div className="d-flex align-items-center flex-wrap mr-1">
                    <div className="d-flex align-items-baseline flex-wrap mr-5">
                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                            {  lang.get('messages.nuevo_plantilla_de_documento') }
                        </h5>
                    </div>
                </div>
                </div>
            </div>
            <div className="d-flex flex-column-fluid">
                <div className="container">
                    <div className="row align-items-center mb-6">
                        <div className="col-sm-auto">
                            <p className="font-weight-bold m-0">{lang.get('messages.que_tipo_de_plantilla_necesitas')}</p>
                        </div>
                        <div className="col-3">
                            <select className="form-control form-control-solid bg-white"  value={this.state.documentCategory} onChange={this.handleSelectChange}  > 
                                {this.state.documentTypesCategories.map((t, i) => { 
                                    return  (
                                        <option  key={i}  value={t.id}  > 
                                            { t.name}
                                        </option>
                                    ); 
                                })}
                            </select>
                        </div>
                    </div>
                    {this.state.loading && (
                        <div className="row align-items-center mb-6">
                            <div className="col">
                                
                                {documentCategory == GENERAL_CATEGORY &&   <GeneralDocumentForm  
                                    upload_document_template= { this.props.upload_document_template} 
                                    download_document_template= { this.props.download_document_template} 
                                    delete_document_template= { this.props.delete_document_template} 
                                    update_document_template= { this.props.update_document_template}  
                                    document={this.state.document}
                                    category={documentCategory}
                                /> } 
                                {documentCategory == AUTOMATIC_CATEGORY &&   <AutomaticDocumentForm 
                                    upload_document_template= { this.props.upload_document_template} 
                                    download_document_template= { this.props.download_document_template} 
                                    delete_document_template= { this.props.delete_document_template} 
                                    update_document_template= { this.props.update_document_template}  
                                    document={this.state.document}
                                    category={documentCategory}
                                /> } 
                                {documentCategory == DOC2SIGN_CATEGORY &&   <Doc2SignDocumentForm 
                                    upload_document_template= { this.props.upload_document_template} 
                                    download_document_template= { this.props.download_document_template} 
                                    delete_document_template= { this.props.delete_document_template} 
                                    update_document_template= { this.props.update_document_template} 
                                    category={documentCategory} 
                                /> } 
                                {documentCategory == CFDI_CATEGORY &&   <MassiveCfdiForm 
                                    upload_document_template= { this.props.upload_document_template} 
                                    download_document_template= { this.props.download_document_template} 
                                    delete_document_template= { this.props.delete_document_template} 
                                    update_document_template= { this.props.update_document_template}  
                                    category={documentCategory}
                                /> }  
                            </div>
                        </div>
                    )}
                </div>
            </div> 
        </>
        );
    }
}

export default DocumentForm;

if (document.getElementById('DocumentForm')) {
    ReactDOM.render(<DocumentForm />, document.getElementById('DocumentForm'));
}
